import {FC, useCallback, useEffect, useState} from 'react';
import Card from './Card';
import Spinner from '../../common/Spinner';
import Error from '../../common/Error';
import CardsSlider from '../slider/CardsSlider';
import {getCards, getCardTypes} from '../../../api/dashboard';
import {getCardCodes} from '../helpers/getCardCodes';
import {getFullCardsInfo} from '../helpers/getFullCardsInfo';
import {CardDescriptionWithCount} from '../types';
import {DEFAULT_ERROR} from '../../../api/constants';

const SLIDER_SETTINGS = {
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const LiveDataCards: FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Nullable<string>>(null);
  const [cardTypes, setCardTypes] =
    useState<Nullable<CardDescriptionWithCount[]>>(null);

  const loadCardTypes = useCallback(async () => {
    setIsLoading(true);

    try {
      const receivedCardTypes = await getCardTypes();

      const cardCodes = getCardCodes(receivedCardTypes);

      const initialCardStates = await getCards({types: cardCodes});

      const fullCardsInfo =
        getFullCardsInfo(receivedCardTypes, initialCardStates);

      setCardTypes(fullCardsInfo);
    } catch (error) {
      setError(error?.message || DEFAULT_ERROR);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCardTypes();
  }, []);

  if (error) {
    return <Error message={error} />;
  }

  return (
    <Spinner isLoading={isLoading}>
      <div className="live-data-cards">
        <CardsSlider settings={SLIDER_SETTINGS}>
          {cardTypes?.map(({code, desc, count}) => (
            <Card
              key={desc}
              code={code}
              count={count}
            />
          ))}
        </CardsSlider>
      </div>
    </Spinner>
  );
};

export default LiveDataCards;
